module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-31.a3f7bb76.png";